module.exports = "app-responsive-breakpoints {\n  display: block;\n}\napp-responsive-breakpoints .visible-xs-or-sm-block {\n  display: none !important;\n}\n@media (max-width: 991px) {\n  app-responsive-breakpoints .visible-xs-or-sm-block {\n    display: block !important;\n  }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/responsive-breakpoints/styles/responsive-breakpoints.scss
// module id = ./src/app/system/core/responsive-breakpoints/styles/responsive-breakpoints.scss
// module chunks = main